import React from "react";
import { useTranslation } from "react-i18next";
import GroupItem from "./GroupItem";

const ResultsSection = ({
  searchFilters,
  filteredGroups,
  selectedPageNames,
  setSelectedPageNames,
  pageNameDefault,
  handleUpdate,
  loadingStates,
  pageLanguage,
}) => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === "fa";
  const massagesClass = isRTL ? "groupPage-guide-message-fa" : "groupPage-guide-message";
  const tableClass = pageLanguage === "fa" ? "groupPage-table-fa" : "groupPage-table-en";

  if (searchFilters.selectedGroupId === "" && !searchFilters.productGroupId) {
    return <div className={massagesClass}>{t("groupPage_guide_message")}</div>;
  }

  return (
    <div className="table-responsive mt-3">
      <table className={`table table-striped table-hover ${tableClass}`}>
        <thead style={{ backgroundColor: "rgba(152, 152, 152, 0.5)" }}>
          <tr>
            <th scope="col" className="text-white">
              {pageLanguage === "fa" ? t("groupPage_fa_name") : t("groupPage_en_name")}
            </th>
            <th scope="col" className="text-white">
              {t("groupPage_product_group_id")}
            </th>
            <th scope="col" className="text-white">
              #
            </th>
          </tr>
        </thead>
        <tbody>
          {filteredGroups.map((group) => (
            <GroupItem
              key={group.ProductGroupId}
              group={group}
              selectedPageNames={selectedPageNames}
              setSelectedPageNames={setSelectedPageNames}
              pageNameDefault={pageNameDefault}
              handleUpdate={handleUpdate}
              loadingStates={loadingStates}
              pageLanguage={pageLanguage}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ResultsSection;
